// The signed-out shell. Same markup and same classes as the old `#gatewrap`, so gate.css
// applies unchanged.

import type { ReactNode } from 'react';

export function Gate({ message, children }: { message?: string; children?: ReactNode }) {
  return (
    <div className="wrap">
      <div className="gate">
        <p className="eyebrow" style={{ justifyContent: 'center' }}>
          <span className="mark">Cartesia</span>
          <span className="brandsep" />
          Demand Gen
        </p>
        <h1>
          Outbound <span className="accent">Dashboard</span>
        </h1>
        {message ? <p>{message}</p> : null}
        {children}
      </div>
    </div>
  );
}

// Signed in, verified, and not allowed in.
//
// A separate state from the sign-in gate and from an expired session: signing in again changes
// nothing, so the page must not offer it. The server sends this as a 403 on the first data
// request. The sign-out button is the only way out for somebody who landed on the wrong
// account, which is why it is here and the sign-in form is not.
export function DeniedGate({
  message,
  email,
  onSignOut,
}: {
  message: string;
  email: string | null;
  onSignOut: () => void;
}) {
  return (
    <Gate>
      <div className="err">
        <b>You do not have access to this dashboard.</b>
        <br />
        {message}
      </div>
      {email ? <p className="denied-who">Signed in as {email}.</p> : null}
      <p className="denied-who">
        This page carries named customer contacts, so access is granted per person rather than
        to everyone with a Cartesia account.
      </p>
      <button className="btn" onClick={onSignOut}>
        Sign out
      </button>
    </Gate>
  );
}
